export type ChannelDeletionAttribution =
  | { kind: 'nationalOffice'; name: string }
  | { kind: 'central'; regionName: string; name: string }
  | { kind: 'operatorOnly'; name: string }

export interface ChannelDeletionAttributionInput {
  deletedBySysAdmin?: boolean | null
  deletedByRegionId?: string | null
  deletedByRegionName?: string | null
  deletedByName: string
}

// A super admin deletes as the national office even when their account belongs to a central, so the
// trace names them the way their own messages do. A trace written before the flag existed falls back
// on the moderator's central: none means the national office. When they have one the name simply
// did not resolve, and claiming the national office there would misattribute the deletion for good
// — the rules refuse to rewrite a trace once written.
export const channelDeletionAttribution = ({
  deletedBySysAdmin,
  deletedByRegionId,
  deletedByRegionName,
  deletedByName,
}: ChannelDeletionAttributionInput): ChannelDeletionAttribution => {
  if (deletedBySysAdmin || !deletedByRegionId) {
    return { kind: 'nationalOffice', name: deletedByName }
  }
  return deletedByRegionName
    ? { kind: 'central', regionName: deletedByRegionName, name: deletedByName }
    : { kind: 'operatorOnly', name: deletedByName }
}
